import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ~ ")


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (value, label) => {
    return _renderSlot(_ctx.$slots, "default", { key: value }, () => [
      _createElementVNode("td", {
        class: _normalizeClass(["module_data_value", label])
      }, [
        value
          ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
              _createTextVNode(_toDisplayString(value), 1)
            ])
          : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
              _hoisted_1
            ])
      ], 2)
    ])
  }), 128))
}
}

})